import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Home from './home';
import ProjectList from './projectList';
import Project from './project';
import ProjectUpdate from './projectUpdate'
import BuyerMapList from './buyerMapList';
import BuyerMapDetail from './buyerMapDetail';
import StrategyMapList from './strategyMapList';
import StrategyMapDetail from './strategyMapDetail';
import ToBeStrategyMapList from './toBeStrategyMapList';
import ToBeStrategyMapDetail from './toBeStrategyMapDetail';
import SignIn from './signIn';
import Register from './register'
import NonCustomersList from './nonCustomersList';
import NonCustomersDetail from './nonCustomersDetail';
import ERRCDetail from './errcDetail';
import ERRCList from './errcList';
import InDeveloping from './indeveloping';
import SideBar from '../components/sideBar';
import AppBarMenu from '../components/appBar';
import Contacts from './contacts'
import { makeStyles, useTheme } from '@material-ui/core/styles';



const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
    'padding-left': theme.spacing(14),
    'padding-top': theme.spacing(10),
    float: 'left',
    position: 'relative',
    Zindex: '-100'
  },
  }
));



export default function Routes({location, signOutUser}) {
    const classes = useStyles();

    return (
      <>

        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/signin" component={SignIn}/>
          <Route exact path="/project" component={ProjectList}/>
          <Route exact path="/register" component={Register}/>
          <Route exact path="/contacts" component={Contacts}/>
        </Switch>

        <main className={classes.content}>
          <Switch>
              <Route exact path="/project/:projectId/" component={Project}/>
              <Route exact path="/project/:projectId/update" component={ProjectUpdate}/>
              <Route exact path="/project/:projectId/buyermap" component={BuyerMapList}/>
              <Route exact path="/project/:projectId/buyermap/:chartId" component={BuyerMapDetail}/>
              <Route exact path="/project/:projectId/strategymap/" component={StrategyMapList}/>
              <Route exact path="/project/:projectId/strategymap/:chartId" component={StrategyMapDetail}/>
              <Route exact path="/project/:projectId/tobestrategymap/" component={ToBeStrategyMapList}/>
              <Route exact path="/project/:projectId/tobestrategymap/:chartId" component={ToBeStrategyMapDetail}/>
              <Route exact path="/project/:projectId/noncustomers/" component={NonCustomersList}/>
              <Route exact path="/project/:projectId/noncustomers/:chartId" component={NonCustomersDetail}/>
              <Route exact path="/project/:projectId/errc/" component={ERRCList}/>
              <Route exact path="/project/:projectId/errc/:chartId" component={ERRCDetail}/>
              <Route exact path="/project/:projectId/developing" component={InDeveloping}/>
          </Switch>
        </main>
        <Switch>
          <Route exact path="/project" component={AppBarMenu}/>

          <Route exact path="/project/:projectId/" component={SideBar}/>
          <Route exact path="/project/:projectId/update" component={SideBar}/>
          <Route exact path="/project/:projectId/buyermap" component={SideBar}/>
          <Route exact path="/project/:projectId/buyermap/:chartId" component={SideBar}/>
          <Route exact path="/project/:projectId/strategymap/" component={SideBar}/>
          <Route exact path="/project/:projectId/strategymap/:chartId" component={SideBar}/>
          <Route exact path="/project/:projectId/tobestrategymap/" component={SideBar}/>
          <Route exact path="/project/:projectId/tobestrategymap/:chartId" component={SideBar}/>
          <Route exact path="/project/:projectId/noncustomers/" component={SideBar}/>
          <Route exact path="/project/:projectId/noncustomers/:chartId" component={SideBar}/>
          <Route exact path="/project/:projectId/errc/" component={SideBar}/>
          <Route exact path="/project/:projectId/errc/:chartId" component={SideBar}/>
          <Route exact path="/project/:projectId/developing" component={SideBar}/>

        </Switch>

        <Switch>
          <Route exact path="/contacts" component={AppBarMenu}/>
        </Switch>
      </>
    )
}
